import { IconButton } from "@mui/material";
import { useMenuStyles } from "./use-menu-styles";
import { useTheme } from "@/contexts/theme/useTheme";
import { MoreCircleIcon } from "@/icons";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface MenuTriggerButtonProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  size?: "small" | "medium" | "large";
  iconSize?: number;
  "aria-label"?: string;
  sx?: object;
}

const MenuTriggerButton = ({
  onClick,
  size = "small",
  iconSize = 22,
  "aria-label": ariaLabel = "Open menu",
  sx,
}: MenuTriggerButtonProps) => {
  const { isHpClient, triggerButtonSx, iconStyle } = useMenuStyles();

  const { getIconOverride } = useTheme();

  const Icon = isHpClient
    ? (getIconOverride("MoreVertIcon") ?? MoreVertIcon)
    : MoreCircleIcon;

  const resolvedSx = {
    ...(isHpClient ? iconStyle : {}),
    width: iconSize,
    height: iconSize,
    display: "block",
  };

  return (
    <IconButton
      onClick={onClick}
      size={size}
      aria-label={ariaLabel}
      disableRipple={isHpClient}
      sx={[
        triggerButtonSx,
        isHpClient && { borderRadius: "8px !important" },
        sx,
      ]}
    >
      <Icon sx={resolvedSx} />
    </IconButton>
  );
};

export { MenuTriggerButton };
